import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminGuard } from '../guards/admin.guard';
import { LoginComponent } from './components/login/login.component';
import { GenerateReportsComponent } from './components/generate-reports/generate-reports.component';
import { UsersComponent } from './components/users/users.component';
import { HomeComponent } from './components/home/home.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'home', component: HomeComponent, canActivate: [AdminGuard] },
  {
    path: 'users',
    component: UsersComponent,
    canActivate: [AdminGuard],
  },
  {
    path: 'generate-reports',
    component: GenerateReportsComponent,
    canActivate: [AdminGuard],
  },
  { path: '**', redirectTo: '/eis/home' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportingSystemRoutingModule {}
